var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "w-full" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.items, function (item) {
        return _c("tr", [
          _c("td", { staticClass: "text-left px-4 py-4 align-top" }, [
            _c("div", { staticClass: "flex items-start" }, [
              _c(
                "div",
                {
                  staticClass:
                    "w-full md:w-28 bg-gray-100 square-box relative overflow-hidden mr-4",
                },
                [
                  _c("picture", [
                    _c("img", {
                      staticClass:
                        "object-cover h-full w-full absolute transform group-hover:scale-110 transition-transform ease-in-out duration-500 rounded-md",
                      attrs: {
                        src: `/storage/${item.event.primary_image.path}`,
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "font-semibold uppercase mb-1 -mt-1" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.event.name) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-gray-500 text-sm font-medium leading-5",
                  },
                  [
                    _c("div", [
                      _vm._v("Date: " + _vm._s(item.date.start_date_no_time)),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v("Seats: " + _vm._s(item.quantity))]),
                    _vm._v(" "),
                    _vm._l(item.addOns, function (addOn) {
                      return _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(addOn.addOn.name) +
                            ": " +
                            _vm._s(addOn.addOnOption.name) +
                            " x " +
                            _vm._s(addOn.quantity) +
                            "\n                        "
                        ),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "text-right px-4 py-4 align-top" }, [
            _vm._v("£" + _vm._s(item.formatted_total)),
          ]),
          _vm._v(" "),
          _vm._m(1, true),
          _vm._v(" "),
          _c("td", { staticClass: "text-right px-4 py-4 align-top" }, [
            _vm._v("£" + _vm._s(item.formatted_total)),
          ]),
        ])
      }),
      _vm._v(" "),
      _vm.membershipDiscount > 0
        ? _c("tr", [
            _c(
              "td",
              {
                staticClass:
                  "text-right px-4 py-4 align-top border-t border-gray-100",
                attrs: { colspan: "3" },
              },
              [_vm._v("\n            Membership Discount\n        ")]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass:
                  "text-right px-4 py-4 align-top border-t border-gray-100",
              },
              [_vm._v("- £" + _vm._s(_vm.membershipDiscount))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("tr", [
        _c(
          "td",
          {
            staticClass:
              "text-right px-4 py-4 align-top border-t border-gray-100 font-semibold",
            attrs: { colspan: "3" },
          },
          [_vm._v("\n            Total\n        ")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticClass:
              "text-right px-4 py-4 align-top border-t border-gray-100",
          },
          [_vm._v("£" + _vm._s(_vm.total))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { staticClass: "font-josefin uppercase text-left px-4 pb-4" }, [
        _vm._v("Item"),
      ]),
      _vm._v(" "),
      _c("th", { staticClass: "font-josefin uppercase text-right px-4 pb-4" }, [
        _vm._v("Price"),
      ]),
      _vm._v(" "),
      _c(
        "th",
        { staticClass: "font-josefin uppercase text-center px-4 pb-4" },
        [_vm._v("Quantity")]
      ),
      _vm._v(" "),
      _c("th", { staticClass: "font-josefin uppercase text-right px-4 pb-4" }, [
        _vm._v("Subtotal"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "text-center px-4 py-4 align-top" }, [
      _c("div", [_vm._v("1")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }